// extracted by mini-css-extract-plugin
export const header = "HeaderNavBar-module--header--1wXvJ";
export const menuIcon = "HeaderNavBar-module--menu-icon--2VwEU";
export const navicon = "HeaderNavBar-module--navicon--1x68P";
export const menuLabel = "HeaderNavBar-module--menu-label--2rooY";
export const menuButton = "HeaderNavBar-module--menu-button--2HVI3";
export const menuButtonOpened = "HeaderNavBar-module--menu-button-opened--21EAm";
export const steps = "HeaderNavBar-module--steps--nP-9w";
export const navbarsContainer = "HeaderNavBar-module--navbars-container--2IZMc";
export const navbarsContainerExpanded = "HeaderNavBar-module--navbars-container-expanded--3BZdU";
export const headerContainer = "HeaderNavBar-module--header-container--1MCpn";
export const brandLogo = "HeaderNavBar-module--brand-logo--11Ex4";
export const serviceNavbar = "HeaderNavBar-module--service-navbar--1vm8W";
export const primaryNavbar = "HeaderNavBar-module--primary-navbar--2maep";
export const secondaryNavbar = "HeaderNavBar-module--secondary-navbar--6caBB";